import { redirect } from 'react-router-dom';

import store from 'config/redux/index';
import { error } from 'config/redux/slice';
import { AppConstants, RouteConstants } from '../constants';
import { ServiceModel } from 'models';
import { AppUtils } from 'utils';
import { PublicService } from 'services';
import { navigate } from 'utils/navigation';

const { SUPPORTED_ERRORS_CODES } = AppConstants;
const { ROUTE_LOGIN } = RouteConstants;

export async function handleErrorWithTokenRenewal(error: any, method: any, methodParams: any[], serviceId: string) {
  let err = JSON.parse(JSON.stringify(error));
  console.log('[API ERROR]', error);
  if (err?.status === 401) {
    try {
      const renewResponse = await PublicService.renew();
      if (renewResponse) {
        setTimeout(() => method(...methodParams), 250);
        return;
      }
      if (window.location.pathname !== ROUTE_LOGIN) {
        AppUtils.logout();
        redirect(ROUTE_LOGIN);
        return;
      }
    } catch (renewError) {
      if (window.location.pathname !== ROUTE_LOGIN) {
        AppUtils.logout();
        redirect(ROUTE_LOGIN);
      }
    }
  } else {
    handleServiceError(serviceId, error);
  }
}

export function handleServiceError(serviceId: string, err: any) {
  let { status, code, response } = err;
  if (status === 400 && response) {
    store.dispatch(error(new ServiceModel(serviceId, response.data)));
    return;
  } else if (SUPPORTED_ERRORS_CODES.includes(status)) {
    errorRedirect(status);
  } else if (code === 'ERR_NETWORK') {
    errorRedirect(503);
  } else if (code === 'ERR_BAD_RESPONSE') {
    errorRedirect(500);
  }
  store.dispatch(error(new ServiceModel(serviceId, err)));
}

function errorRedirect(status: number) {
  navigate('/fehler/' + status);
}